import * as React from 'react';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

import { WithTranslation, withTranslation } from 'react-i18next';
import {
    IcloudDocument,
    Ioption,
    IproductInfo,
    ItableFiltersReducer,
    Itile
} from '../../models';
import ReactTable, { Column, FinalState, RowInfo } from 'react-table';
import {
    clearSelectedDocumentID,
    clearSelectedParentID,
    deleteVersion,
    getCloudDocument,
    getDocuments,
    setSelectedDocumentID,
    setSelectedParentID,
    setTableFilter,
    toggleEditDocumentModal
} from '../../actions/manageDocumentActions';
import {
    deleteDocumentType,
    getDocumentTypes,
    saveDocumentTypes,
    updateDocumentType
} from '../../actions/manageDocumentTypeActions';
import { emptyTile, initialDocument } from '../../reducers/initialState';
import { map } from 'lodash';

import { Button, Col } from 'react-bootstrap';
import { AddButton } from '../common/AddButton';
import { Banner } from '../common/Banner';
import EditDocumentLibraryModal from './dialogs/EditDocumentLibraryModal';
import { EditDocumentTypeModal } from './dialogs/EditDocumentTypeModal';
import { FieldConfig } from 'react-reactive-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormUtil } from '../common/FormUtil';
import { Iuser } from '../../models';
import { RouteComponentProps } from 'react-router';
import SearchTableForm from '../common/SearchTableForm';
import { TableUtil } from '../common/TableUtil';
import { connect, useSelector } from 'react-redux';
import { constants, DocumentTypesEnum } from '../../constants/constants';
import {
    getFacilitiesByCountry,
    closeAllModals
} from '../../actions/commonActions';
import { IinitialState } from '../../reducers';
import { selectIsLoading } from '../../reducers/commonReducers';
import { getIsMobile } from '../../reducers/configReducer';
import ManageDocumentVersions from './mobile/ManageDocumentVersions';
import { selectSelectedFacilityID } from '../../reducers/facilitiesReducer';
import { dateRangeEnum, jobTypesIdEnum } from '../../models-enums';
import PreviewDocumentModal from './dialogs/PreviewDocumentModal';
import {
    getDocumentDisplayName,
    getDocumentDisplayVersion,
    getDocumentMimeType,
    getDocumentRawName,
    getLastModifiedDate,
    getLatestVersion,
    getVersionDisplayNumber,
    resolveFacilityColumnValue,
    sortVersionsNewestFirst
} from './utils/ManageDocumentUtils';
import FileTypeIcon from './FileTypeIcon';
import {
    nextSortState,
    SortableColumnHeader,
    SortState
} from '../common/SortableColumnHeader';
import { getProductInfo } from '../../actions/manageInventoryActions';
import useFiltersHeight from '../common/useFiltersHeight';
import { formatLocalTime } from '../../helpers/formatLocalTime';
import { documentTypeSelector } from '../../reducers/documentTypeReducer';
import { toastr } from 'react-redux-toastr';
import NewVersionIcon from '../../images/add.svg';
export interface RowInfoDocument extends RowInfo {
    original: IcloudDocument;
}

const isSingleVersionDocument = (doc: IcloudDocument): boolean =>
    !doc.versions || doc.versions.length <= 1;

/*
 * Desktop rows: the group/type/document/version tree is flattened into plain
 * table rows so every row shares one set of columns (a single indented tree
 * column, then the data columns) - header and body cells always line up.
 */
interface IdocumentTreeRow {
    rowType: 'type' | 'doc' | 'version';
    key: string; // expansion key (folder rows) or doc/version id
    label: string;
    level: number; // 0 type folder, 1 document, 2 version
    isExpanded: boolean;
    document?: IcloudDocument; // doc rows: the document; version rows: the version
    parentDocument?: IcloudDocument; // version rows only
    description: string; // raw stored document name; blank on folder rows
    modifiedDate: string;
    modifiedDateTime: string; // hover tooltip: same date with time
    files?: number | string; // folder rows: doc count; doc/version rows: "vN"
}

// Dev aid: localStorage.setItem('debugTableCells', '1') + refresh outlines
// every table cell (headers included) to make column alignment visible
const debugCellsClass = () =>
    localStorage.getItem('debugTableCells') === '1' ? ' debug-cells' : '';

// desktop folder sort persists per browser; default = newest folder first
const FOLDER_SORT_STORAGE_KEY = 'docLibraryFolderSort';
const defaultFolderSort: SortState = {
    column: 'modifiedDate',
    descending: true
};
const loadFolderSort = (): SortState => {
    try {
        const raw = localStorage.getItem(FOLDER_SORT_STORAGE_KEY);
        if (raw) {
            const parsed = JSON.parse(raw);
            if (
                parsed &&
                (parsed.column === 'folder' ||
                    parsed.column === 'modifiedDate' ||
                    parsed.column === null) &&
                typeof parsed.descending === 'boolean'
            ) {
                return parsed;
            }
        }
    } catch (e) {
        // unreadable storage falls back to the default
    }
    return defaultFolderSort;
};

type Iprops = RouteComponentProps<any>;

interface IdispatchProps {
    tableData: IcloudDocument[];
    totalPages: number;
    showEditDocumentModal: boolean;
    getDocumentTypes: typeof getDocumentTypes;
    saveDocumentTypes: typeof saveDocumentTypes;
    deleteDocumentType: typeof deleteDocumentType;
    updateDocumentType: typeof updateDocumentType;
    getDocuments: typeof getDocuments;
    toggleEditDocumentModal: typeof toggleEditDocumentModal;
    loading: boolean;
    setTableFilter: typeof setTableFilter;
    tableFilters: ItableFiltersReducer;
    setSelectedParentID: typeof setSelectedParentID;
    clearSelectedParentID: typeof clearSelectedParentID;
    setSelectedDocumentID: typeof setSelectedDocumentID;
    clearSelectedDocumentID: typeof clearSelectedDocumentID;
    getCloudDocument: typeof getCloudDocument;
    deleteVersion: typeof deleteVersion;
    selectedDocument: IcloudDocument;
    getFacilitiesByCountry: typeof getFacilitiesByCountry;
    getProductInfo: typeof getProductInfo;
    user: Iuser;
    selectedFacilityID: string;
    canEditDocuments: boolean;
    canAddDocuments: boolean;
    canDeleteSystemDocuments: boolean;
    mainCategoryOptions: Ioption[];
    productInfo: IproductInfo;
    closeAllModals: typeof closeAllModals;
}

interface Istate {
    selectedRow: any;
    currentTile: Itile;
    columns: any[];
    modalVersionVisible: boolean;
    selectedCloudDocument: IcloudDocument;
    showPreviewDocumentModal: boolean;
    documentToPreview: IcloudDocument;
    previewSpecificVersion: boolean;
    expandedFolders: { [key: string]: boolean };
    expandedDocs: { [docID: string]: boolean };
}

const isInstallBaseSearch = (): boolean => {
    const regex = /^\?installbaseId=.*$/i;
    const location = window.location.search;
    return location !== '' && location.match(regex) !== null;
};

const ManageDocumentLibrary: React.FC<IdispatchProps &
    Iprops &
    WithTranslation> = props => {
    const { t, tableData, tableFilters, totalPages, i18n } = props;

    const documentTypeOptions = useSelector(documentTypeSelector);
    const isMobile = useSelector(getIsMobile);
    const selectedFacilityID = useSelector(selectSelectedFacilityID);
    const prevSelectedFacilityID = React.useRef<string>(selectedFacilityID);
    const location = useLocation();
    // state.currentTile is never set on this screen, so resolve it from the route
    const currentTile = constants.getTileByURL(location.pathname);
    const resetFilters = () => {
        props.setTableFilter({
            assetSearch: '',
            name: undefined,
            mainCategory: undefined,
            type: undefined,
            dateRange: undefined,
            isSystem: undefined,
            jobType: undefined
        });
    };

    React.useEffect(() => {
        prevSelectedFacilityID.current = selectedFacilityID;
    }, [selectedFacilityID]);

    const fieldConfig = React.useMemo(() => {
        if (selectedFacilityID !== prevSelectedFacilityID.current) {
            resetFilters();

            props.getDocuments(props.t, {});
        }

        const isInstallBase = isInstallBaseSearch();
        const mainSearchControls = {
            assetSearch: {
                render: FormUtil.TextInputWithoutValidation,
                meta: {
                    label: t('manageDocument:assetAndJob'),
                    colWidth: isMobile ? 12 : 3,
                    colWidthLarge: 2,
                    type: 'text',
                    placeholder: isMobile
                        ? 'common:searchNamePlaceholder'
                        : 'common:searchPlaceholder',
                    defaultValue: isInstallBase
                        ? ''
                        : props.tableFilters.assetSearch,
                    isClearable: true
                },
                formState: { disabled: isInstallBase, value: '' }
            },
            mainCategory: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('common:mainCategory'),
                    options: props.mainCategoryOptions,
                    colWidth: isMobile ? 12 : 3,
                    colWidthLarge: 2,
                    type: 'select',
                    placeholder: t('common:selectPlaceholder'),
                    defaultValue: '',
                    isClearable: true
                }
            },
            type: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('manageDocument:type'),
                    options: FormUtil.convertToOptions(documentTypeOptions),
                    colWidth: isMobile ? 12 : 3,
                    colWidthLarge: 2,
                    type: 'select',
                    placeholder: isMobile
                        ? t('common:selectTypePlaceholder')
                        : t('DocumentType'),
                    defaultValue: isInstallBase ? '' : props.tableFilters.type,
                    isClearable: true
                }
            },
            jobType: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('manageDocument:jobType'),
                    options: FormUtil.convertEnumToOptions(jobTypesIdEnum),
                    colWidth: isMobile ? 12 : 2,
                    colWidthMedium: isMobile ? 12 : 2,
                    colWidthLarge: 2,
                    type: 'select',
                    placeholder: isMobile
                        ? t('common:selectTypePlaceholder')
                        : t('DocumentType'),
                    defaultValue: isInstallBase
                        ? ''
                        : props.tableFilters.jobType,
                    isClearable: true,
                    shouldTranslate: true
                }
            },
            dateRange: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('manageDocument:date'),
                    options: FormUtil.convertEnumToOptions(dateRangeEnum),
                    // mobile: shares the last filter row with Is System
                    // and the add (+) button
                    colWidth: isMobile ? 5 : 2,
                    colWidthLarge: 2,
                    dataType: 'date-filter',
                    placeholder: t('manageDocument:quarterYearAllTime'),
                    isClearable: true,
                    shouldTranslate: true,
                    type: 'select',
                    defaultValue: isInstallBase
                        ? ''
                        : props.tableFilters.dateRange
                }
            },
            isSystem: {
                render: FormUtil.SelectWithoutValidation,
                meta: {
                    label: t('manageDocument:system'),
                    options: [
                        {
                            value: 'true',
                            label: t('manageDocument:yes')
                        },
                        {
                            value: 'false',
                            label: t('manageDocument:no')
                        }
                    ],
                    colWidth: isMobile ? 5 : 2,
                    colWidthLarge: 2,
                    colWidthMedium: isMobile ? 5 : 2,
                    type: 'select',
                    placeholder: t('common:selectPlaceholder'),
                    defaultValue: props.tableFilters.isSystem,
                    isClearable: true,
                    shouldTranslate: true
                },
                formState: {
                    disabled: isInstallBase,
                    value: isInstallBase
                        ? {
                              value: 'true',
                              label: props.t('manageDocument:yes')
                          }
                        : ''
                }
            }
        };

        const searchFieldConfig = {
            controls: { ...mainSearchControls }
        } as FieldConfig;
        return searchFieldConfig;
        // eslint-disable-next-line
    }, [
        documentTypeOptions,
        prevSelectedFacilityID,
        selectedFacilityID,
        location.search,
        props.t,
        i18n.language,
        isMobile
    ]);

    const [state, setState] = React.useState<Istate>({
        selectedRow: {},
        currentTile: emptyTile,
        columns: [],
        modalVersionVisible: false,
        selectedCloudDocument: initialDocument,
        showPreviewDocumentModal: false,
        documentToPreview: initialDocument,
        previewSpecificVersion: false,
        expandedFolders: {},
        expandedDocs: {}
    });
    // size the table to whatever the filter area really occupies
    const screenRef = useFiltersHeight([
        isMobile,
        Object.keys(state.selectedRow).length > 0
    ]);

    const [folderSort, setFolderSort] = React.useState<SortState>(
        loadFolderSort
    );
    const handleFolderSort = (columnKey: string) => {
        setFolderSort(prev => {
            const next = nextSortState(prev, columnKey);
            try {
                localStorage.setItem(
                    FOLDER_SORT_STORAGE_KEY,
                    JSON.stringify(next)
                );
            } catch (e) {
                // storage unavailable (private mode) - sort still applies
            }
            return next;
        });
    };
    let debounce: any;

    const onPageChange = (page: number) => {
        const newPage = page + 1;
        props.setTableFilter({ page: newPage });
    };

    /*
     * Set Columns sets columns to state
     */
    const setColumns = () => {
        if (isMobile) {
            const mobileColumns = TableUtil.translateHeaders(
                [
                    {
                        Header: 'name',
                        accessor: 'name',
                        // stacked cards: keep react-table's row min-width
                        // (sum of column minWidths) under the viewport
                        minWidth: 60,
                        // eslint-disable-next-line no-shadow
                        Cell: props => (
                            <div className="mngDoc-header-column">
                                <p className="mngDoc-table-mobile-header">
                                    Name
                                </p>{' '}
                                <p className="mngDoc-table-value first-row">
                                    <FileTypeIcon
                                        mimeType={getDocumentMimeType(
                                            props.original
                                        )}
                                    />
                                    {getDocumentDisplayName(
                                        props.original,
                                        documentTypeOptions
                                    )}
                                </p>
                                <p className="mngDoc-version-chip">
                                    {`V${getDocumentDisplayVersion(
                                        props.original
                                    )}`}
                                </p>
                            </div>
                        )
                    },
                    {
                        Header: 'documentDescription',
                        id: 'description',
                        minWidth: 60,
                        accessor: (doc: IcloudDocument) =>
                            getDocumentRawName(doc),
                        // eslint-disable-next-line no-shadow
                        Cell: props => (
                            <div className="mngDoc-header-column">
                                <p className="mngDoc-table-mobile-header">
                                    {t('manageDocument:description')}
                                </p>{' '}
                                <p className="mngDoc-table-value first-row">
                                    {props.value}
                                </p>
                            </div>
                        )
                    },
                    {
                        Header: 'documentDescription',
                        id: 'description',
                        minWidth: 60,
                        accessor: (doc: IcloudDocument) =>
                            getDocumentRawName(doc),
                        // eslint-disable-next-line no-shadow
                        Cell: props => (
                            <div className="mngDoc-header-column">
                                <p className="mngDoc-table-mobile-header">
                                    {t('manageDocument:description')}
                                </p>{' '}
                                <p className="mngDoc-table-value first-row">
                                    {props.value}
                                </p>
                            </div>
                        )
                    },
                    {
                        Header: 'type',
                        minWidth: 60,
                        accessor: ({ cloudDocumentTypeID }: IcloudDocument) => {
                            if (
                                documentTypeOptions &&
                                documentTypeOptions[cloudDocumentTypeID]
                            ) {
                                return documentTypeOptions[cloudDocumentTypeID]
                                    .name;
                            } else {
                                return '';
                            }
                        },
                        id: 'type',
                        // eslint-disable-next-line no-shadow
                        Cell: props => (
                            <div className="mngDoc-header-column">
                                <p className="mngDoc-table-mobile-header">
                                    Type
                                </p>{' '}
                                <p className="mngDoc-table-value first-row">
                                    {props.value}
                                </p>
                            </div>
                        )
                    },
                    {
                        Header: 'common:facility',
                        minWidth: 60,
                        accessor: (doc: IcloudDocument) =>
                            resolveFacilityColumnValue(doc),
                        id: 'facility',
                        // eslint-disable-next-line no-shadow
                        Cell: props => (
                            <div className="mngDoc-header-column">
                                <p className="mngDoc-table-mobile-header">
                                    Facility
                                </p>{' '}
                                <p className="mngDoc-table-value first-row">
                                    {props.value}
                                </p>
                            </div>
                        )
                    },
                    {
                        Header: 'manageDocument:modifiedDate',
                        id: 'jobDate',
                        minWidth: 60,
                        // short fields share one row to keep the card compact
                        // eslint-disable-next-line no-shadow
                        Cell: props => {
                            const doc: IcloudDocument = props.original;
                            const date = moment(
                                getLastModifiedDate(
                                    getLatestVersion(doc) || doc
                                )
                            )
                                .local(true)
                                .format('DD-MMM-YY');
                            return (
                                <div className="mngDoc-cell-pair">
                                    {doc.jobNumber ? (
                                        <div className="mngDoc-header-column">
                                            <p className="mngDoc-table-mobile-header">
                                                Job #
                                            </p>{' '}
                                            <p className="mngDoc-table-value first-row">
                                                {doc.jobNumber}
                                            </p>
                                        </div>
                                    ) : null}
                                    <div className="mngDoc-header-column">
                                        <p className="mngDoc-table-mobile-header">
                                            Date
                                        </p>{' '}
                                        <p className="mngDoc-table-value first-row">
                                            {date}
                                        </p>
                                    </div>
                                </div>
                            );
                        }
                    }
                ],
                props.t
            );
            setState({ ...state, columns: mobileColumns });
        } else {
            // Desktop
            const centered = {
                headerStyle: { textAlign: 'center' },
                style: { textAlign: 'center' }
            };
            const columns = TableUtil.translateHeaders(
                [
                    {
                        id: 'tree',
                        Header: (
                            <SortableColumnHeader
                                label={String(props.t('folder'))}
                                columnKey="folder"
                                sort={folderSort}
                                onSort={handleFolderSort}
                            />
                        ),
                        minWidth: 300,
                        style: { cursor: 'pointer', userSelect: 'none' },
                        Cell: ({
                            original
                        }: {
                            original: IdocumentTreeRow;
                        }) => {
                            const isFolderRow = original.rowType === 'type';
                            const isMultiDocRow =
                                original.rowType === 'doc' &&
                                original.document !== undefined &&
                                !isSingleVersionDocument(original.document);
                            // version rows indent like their parent doc row
                            const indentLevel =
                                original.rowType === 'version'
                                    ? 1
                                    : original.level;
                            const chevronStyle = original.isExpanded
                                ? { transform: 'rotate(0)' }
                                : { transform: 'rotate(-90deg)' };
                            const rowDocument = original.document;
                            // doc/version rows show their file type as a
                            // colorized icon in the folder icon's slot;
                            // hover shows the type name
                            const fileIcon =
                                rowDocument !== undefined ? (
                                    <FileTypeIcon
                                        mimeType={rowDocument.mimeType}
                                        className="tree-folder-slot"
                                    />
                                ) : null;
                            return (
                                <span
                                    className={`tree-cell tree-level-${indentLevel}`}
                                >
                                    {isFolderRow &&
                                        TableUtil.expanderToggleFolder({
                                            isExpanded: original.isExpanded
                                        } as any)}
                                    {isMultiDocRow && (
                                        // expandable doc: chevron sits left of
                                        // the file icon, mirroring folder rows
                                        <span>
                                            <FontAwesomeIcon
                                                icon="chevron-down"
                                                style={chevronStyle}
                                                className="beacon-expander-toggle"
                                            />
                                            {fileIcon}
                                        </span>
                                    )}
                                    {!isFolderRow && !isMultiDocRow && (
                                        // flat rows: a hidden chevron keeps the
                                        // icon + text x-position identical to
                                        // expandable rows - no pixel guessing
                                        <span>
                                            <FontAwesomeIcon
                                                icon="chevron-down"
                                                className="beacon-expander-toggle tree-chevron-ghost"
                                            />
                                            {fileIcon}
                                        </span>
                                    )}
                                    {original.label}
                                </span>
                            );
                        }
                    },
                    {
                        id: 'description',
                        Header: 'documentDescription',
                        minWidth: 180,
                        // raw stored name; folder rows carry none
                        accessor: ({ description }: IdocumentTreeRow) =>
                            description,
                        Cell: ({
                            original
                        }: {
                            original: IdocumentTreeRow;
                        }) => (
                            <span title={original.description}>
                                {original.description}
                            </span>
                        )
                    },
                    {
                        id: 'facility',
                        Header: 'common:facility',
                        minWidth: 160,
                        accessor: ({ document }: IdocumentTreeRow) =>
                            resolveFacilityColumnValue(document)
                    },
                    {
                        id: 'jobNumber',
                        Header: 'nsJob:jobNumber',
                        minWidth: 90,
                        ...centered,
                        accessor: ({ document }: IdocumentTreeRow) =>
                            (document && document.jobNumber) || ''
                    },
                    {
                        id: 'modifiedDate',
                        Header: (
                            <SortableColumnHeader
                                label={String(
                                    props.t('manageDocument:modifiedDate')
                                )}
                                columnKey="modifiedDate"
                                sort={folderSort}
                                onSort={handleFolderSort}
                            />
                        ),
                        headerClassName: 'th-sort-centered',
                        minWidth: 100,
                        ...centered,
                        accessor: ({ modifiedDate }: IdocumentTreeRow) =>
                            modifiedDate,
                        Cell: ({
                            original
                        }: {
                            original: IdocumentTreeRow;
                        }) => (
                            <span title={original.modifiedDateTime}>
                                {original.modifiedDate}
                            </span>
                        )
                    },
                    {
                        id: 'files',
                        Header: 'files',
                        minWidth: 70,
                        ...centered,
                        // folder rows show bold file counts; doc/version rows
                        // show their (unbolded) version number
                        Cell: ({
                            original
                        }: {
                            original: IdocumentTreeRow;
                        }) => {
                            if (original.files === undefined) {
                                return null;
                            }
                            return original.rowType === 'type' ? (
                                <strong>{original.files}</strong>
                            ) : (
                                <span>{original.files}</span>
                            );
                        }
                    },
                    {
                        Header: '',
                        id: 'actions',
                        // fixed: sized to the icon cluster so it doesn't
                        // flex-grow into leftover whitespace
                        width: 245,
                        Cell: ({
                            original
                        }: {
                            original: IdocumentTreeRow;
                        }) => {
                            const rowDoc = original.document;
                            if (
                                (original.rowType !== 'doc' &&
                                    original.rowType !== 'version') ||
                                rowDoc === undefined
                            ) {
                                return null;
                            }
                            const isVersionRow = original.rowType === 'version';
                            const parentID =
                                isVersionRow && original.parentDocument
                                    ? original.parentDocument.id
                                    : rowDoc.id;

                            const getActionDocument = ():
                                | IcloudDocument
                                | undefined => {
                                if (isVersionRow) {
                                    return { ...rowDoc, version: rowDoc.id };
                                }
                                const latest = getLatestVersion(rowDoc);
                                if (!latest) {
                                    return undefined;
                                }
                                return {
                                    ...latest,
                                    mimeType: latest.mimeType || rowDoc.mimeType
                                };
                            };

                            const handleViewInTab = (e: any) => {
                                e.stopPropagation();
                                const doc = getActionDocument();
                                if (!doc) return;
                                const result = props.getCloudDocument(
                                    props.t,
                                    doc,
                                    false
                                ) as any;
                                if (
                                    result &&
                                    typeof result.then === 'function'
                                ) {
                                    result.then((blobUrl: string) => {
                                        if (blobUrl) {
                                            window.open(blobUrl, '_blank');
                                        }
                                    });
                                }
                            };

                            const handleDownload = (e: any) => {
                                e.stopPropagation();
                                const doc = getActionDocument();
                                if (!doc) return;
                                props.getCloudDocument(props.t, doc, true);
                            };

                            const handleAddVersion = (e: any) => {
                                e.stopPropagation();
                                props.clearSelectedDocumentID();
                                props.setSelectedParentID(rowDoc.id);
                                props.toggleEditDocumentModal();
                            };

                            // doc rows delete their LATEST version only;
                            // version rows delete that version
                            const deleteTarget = isVersionRow
                                ? rowDoc
                                : getActionDocument();

                            const handleDelete = (e: any) => {
                                e.stopPropagation();
                                if (!deleteTarget) {
                                    return;
                                }
                                const toastrConfirmOptions = {
                                    onOk: () => {
                                        props.deleteVersion(parentID, {
                                            ...deleteTarget
                                        });
                                    },
                                    onCancel: () =>
                                        console.info('CANCEL: clicked'),
                                    okText: props.t('common:delete'),
                                    cancelText: props.t('common:cancel')
                                };
                                toastr.confirm(
                                    props.t('deleteConfirm'),
                                    toastrConfirmOptions
                                );
                            };

                            const canDelete =
                                deleteTarget !== undefined &&
                                props.canEditDocuments &&
                                !(
                                    deleteTarget.isSystem &&
                                    !props.canDeleteSystemDocuments
                                );

                            // folder rows can't click-to-edit (click expands),
                            // so they get an explicit edit pencil for their
                            // latest version
                            const isMultiVersionRow =
                                !isVersionRow &&
                                !isSingleVersionDocument(rowDoc);
                            const handleEditLatest = (e: any) => {
                                e.stopPropagation();
                                const latest = getActionDocument();
                                if (!latest) return;
                                props.setSelectedParentID(rowDoc.id);
                                props.setSelectedDocumentID(latest.id);
                                props.toggleEditDocumentModal();
                            };

                            return (
                                <div className="doc-actions">
                                    {isMultiVersionRow ? (
                                        <span
                                            title={props.t('common:edit')}
                                            onClick={handleEditLatest}
                                        >
                                            <FontAwesomeIcon
                                                icon={['far', 'edit']}
                                            />
                                        </span>
                                    ) : (
                                        <span className="doc-actions-spacer">
                                            <FontAwesomeIcon
                                                icon={['far', 'edit']}
                                            />
                                        </span>
                                    )}
                                    <span
                                        title="View in new tab"
                                        onClick={handleViewInTab}
                                    >
                                        <FontAwesomeIcon
                                            icon={['far', 'external-link-alt']}
                                        />
                                    </span>
                                    <span
                                        title="Download"
                                        onClick={handleDownload}
                                    >
                                        <FontAwesomeIcon
                                            icon={['far', 'download']}
                                        />
                                    </span>
                                    {isVersionRow ? (
                                        <span className="new-version-btn-inline doc-actions-spacer">
                                            <img
                                                src={NewVersionIcon}
                                                alt=""
                                                aria-hidden="true"
                                                className="new-version-icon"
                                            />
                                        </span>
                                    ) : (
                                        <span
                                            className="new-version-btn-inline"
                                            title={props.t(
                                                'manageDocument:newDocument'
                                            )}
                                            onClick={handleAddVersion}
                                        >
                                            <img
                                                src={NewVersionIcon}
                                                alt=""
                                                aria-hidden="true"
                                                className="new-version-icon"
                                            />
                                        </span>
                                    )}
                                    {canDelete ? (
                                        <span
                                            style={{
                                                color: constants.colors.red
                                            }}
                                            title={props.t(
                                                'manageDocument:deleteOk'
                                            )}
                                            onClick={handleDelete}
                                        >
                                            <FontAwesomeIcon
                                                icon={['far', 'times']}
                                            />
                                        </span>
                                    ) : (
                                        <span className="doc-actions-spacer">
                                            <FontAwesomeIcon
                                                icon={['far', 'times']}
                                            />
                                        </span>
                                    )}
                                </div>
                            );
                        }
                    }
                ],
                props.t
            );
            setState({ ...state, columns });
        }
    };

    /*
     * Collapse all table
     */
    const collapseTable = () => {
        setState({
            ...state,
            selectedRow: {},
            expandedFolders: {},
            expandedDocs: {}
        });
    };

    /*
     * Handle user clicking on a product row column
     * set the selected product to state and open the modal
     */
    const getTdProps = (
        finalState: FinalState,
        rowInfo: RowInfo | undefined,
        column: Column | undefined,
        instance: any
    ) => {
        if (isMobile) {
            if (rowInfo) {
                return {
                    onClick: () => {
                        const doc: IcloudDocument = rowInfo.original;
                        // single-version docs edit directly, mirroring the
                        // desktop flat rows; only multi-version docs open
                        // the version-history screen
                        if (isSingleVersionDocument(doc)) {
                            props.setSelectedParentID(doc.id);
                            props.setSelectedDocumentID(doc.id);
                            props.toggleEditDocumentModal();
                            return;
                        }
                        setState({
                            ...state,
                            selectedRow: {
                                [rowInfo.viewIndex || 0]: !state.selectedRow[
                                    rowInfo.viewIndex || 0
                                ]
                            },
                            selectedCloudDocument: doc
                        });
                    }
                };
            }

            return {};
        } else {
            // Desktop
            if (!rowInfo || (column && column.id === 'actions')) {
                return {};
            }
            const row: IdocumentTreeRow = rowInfo.original;
            if (!row) {
                return {};
            }
            return {
                onClick: () => {
                    if (row.rowType === 'type') {
                        setState({
                            ...state,
                            expandedFolders: {
                                ...state.expandedFolders,
                                [row.key]: !state.expandedFolders[row.key]
                            }
                        });
                        return;
                    }
                    const doc = row.document;
                    if (!doc) {
                        return;
                    }
                    if (row.rowType === 'version') {
                        // clicking a version edits that version
                        if (row.parentDocument) {
                            props.setSelectedParentID(row.parentDocument.id);
                        }
                        props.setSelectedDocumentID(doc.id);
                        props.toggleEditDocumentModal();
                        return;
                    }
                    if (isSingleVersionDocument(doc)) {
                        // Flat row: nothing to expand, clicking edits the document
                        props.setSelectedParentID(doc.id);
                        props.setSelectedDocumentID(doc.id);
                        props.toggleEditDocumentModal();
                        return;
                    }
                    const nowExpanded = !state.expandedDocs[doc.id];
                    if (nowExpanded) {
                        props.setSelectedParentID(doc.id);
                    } else {
                        props.clearSelectedParentID();
                    }
                    setState({
                        ...state,
                        expandedDocs: {
                            ...state.expandedDocs,
                            [doc.id]: nowExpanded
                        }
                    });
                }
            };
        }
    };

    const onSearchValueChanges = (value: any, key: string) => {
        switch (key) {
            case 'assetSearch':
            case 'name':
                clearTimeout(debounce);
                debounce = setTimeout(() => {
                    props.setTableFilter({ [key]: value });
                    props.getDocuments(props.t, {
                        ...props.tableFilters,
                        [key]: value
                    });
                }, 1000);
                break;
            case 'mainCategory':
                props.setTableFilter({ mainCategory: value });
                props.getDocuments(props.t, {
                    ...props.tableFilters,
                    mainCategoryID: value?.value
                });
                break;
            case 'type':
                props.setTableFilter({
                    type: value,
                    page: 1
                });
                props.getDocuments(props.t, {
                    ...props.tableFilters,
                    type: value
                });
                break;
            case 'dateRange':
            case 'isSystem':
            case 'jobType':
                props.setTableFilter({
                    [key]: value
                });
                props.getDocuments(props.t, {
                    ...props.tableFilters,
                    [key]: value
                });
                break;
            default:
                break;
        }
    };

    const goBack = () => {
        props.clearSelectedParentID();
        props.clearSelectedDocumentID();
        setState({ ...state, selectedRow: {} });
    };

    const newVersion = (parentDocumentID: string) => {
        props.clearSelectedDocumentID();
        props.setSelectedParentID(parentDocumentID);
        props.toggleEditDocumentModal();
    };

    const editDoc = (documentID: string) => {
        props.setSelectedDocumentID(documentID);
        props.toggleEditDocumentModal();
    };

    React.useEffect(() => {
        props.getDocumentTypes();
        setColumns();

        if (!props.productInfo) {
            props.getProductInfo();
        }

        // The Add Document modal's Facility dropdown reads state.facilities,
        // which USER_LOGIN_SUCCESS seeds with only the user's *assigned*
        // facilities - one, for many users. This is the same call the profile
        // form makes to fill its facility picker; the backend scopes the result
        // to what the caller may see. GET_FACILITIES_SUCCESS merges, so the
        // seeded entries survive.
        props.getFacilitiesByCountry({});
        // eslint-disable-next-line
    }, []);

    React.useEffect(() => {
        setColumns();
        // eslint-disable-next-line
    // eslint-disable-next-line
    }, [Object.keys(documentTypeOptions).length]);

    // desktop and mobile use different column sets - rebuild on layout flips
    React.useEffect(() => {
        setColumns();
        // eslint-disable-next-line
    }, [isMobile]);

    // headers render the active sort state, so rebuild when it changes
    React.useEffect(() => {
        setColumns();
        // eslint-disable-next-line
    }, [folderSort]);

    React.useEffect(() => {
        props.getDocumentTypes();
        setColumns();
        // eslint-disable-next-line
    }, [selectedFacilityID]);

    React.useEffect(() => {
        if (location.search === '' && selectedFacilityID.length) {
            props.getDocuments(props.t, props.tableFilters);
        } else if (selectedFacilityID.length) {
            props.getDocuments(props.t, {});
        }
        // eslint-disable-next-line
    }, [location.search]);

    const downloadMobileDocument = (selectedCloudDocument: IcloudDocument) => {
        props.getCloudDocument(props.t, selectedCloudDocument, true);
    };

    /*
     * Desktop: flatten types > documents into plain rows based on what is
     * expanded, so a single set of columns drives header and body. Type
     * folders sit at the top level (MMG-4001 removed the group tier); docs
     * with an unrecognized type collect in an Additional Documents folder.
     */
    const buildTreeRows = (): IdocumentTreeRow[] => {
        interface ItypeBucket {
            label: string;
            docs: IcloudDocument[];
            isAdditional: boolean;
        }
        const typeBuckets: ItypeBucket[] = [];
        tableData.forEach(doc => {
            let typeLabel = '';
            let isAdditional = false;
            if (doc.otherGroup) {
                typeLabel = props.t('manageDocument:additionalDocuments');
                isAdditional = true;
            } else if (
                documentTypeOptions &&
                documentTypeOptions[doc.cloudDocumentTypeID]
            ) {
                typeLabel = documentTypeOptions[doc.cloudDocumentTypeID].name;
            }
            let typeBucket = typeBuckets.find(tb => tb.label === typeLabel);
            if (!typeBucket) {
                typeBucket = { label: typeLabel, docs: [], isAdditional };
                typeBuckets.push(typeBucket);
            }
            typeBucket.docs.push(doc);
        });
        // user sort applies to FOLDERS only (docs keep their API order);
        // no sort = API order, which is already newest-first. The catch-all
        // folder always renders last.
        const bucketMaxDate = (tb: ItypeBucket) =>
            Math.max(
                ...tb.docs.map(d => moment(getLastModifiedDate(d)).valueOf())
            );
        const namedBuckets = typeBuckets.filter(tb => !tb.isAdditional);
        if (folderSort.column === 'folder') {
            namedBuckets.sort((a, b) =>
                folderSort.descending
                    ? b.label.localeCompare(a.label)
                    : a.label.localeCompare(b.label)
            );
        } else if (folderSort.column === 'modifiedDate') {
            namedBuckets.sort((a, b) =>
                folderSort.descending
                    ? bucketMaxDate(b) - bucketMaxDate(a)
                    : bucketMaxDate(a) - bucketMaxDate(b)
            );
        }
        const orderedTypeBuckets = namedBuckets.concat(
            typeBuckets.filter(tb => tb.isAdditional)
        );

        const formatMoment = (m: moment.Moment, withTime: boolean) =>
            withTime
                ? `${m.format('DD-MMM-YY')} ${formatLocalTime(m.toDate())}`
                : m.format('DD-MMM-YY');
        const formatDate = (doc: IcloudDocument, withTime = false) =>
            formatMoment(
                moment(getLastModifiedDate(doc)).local(true),
                withTime
            );
        const maxDate = (docs: IcloudDocument[], withTime = false) =>
            formatMoment(
                moment.max(
                    docs.map(d => moment(getLastModifiedDate(d)).local(true))
                ),
                withTime
            );

        const rows: IdocumentTreeRow[] = [];
        orderedTypeBuckets.forEach(typeBucket => {
            const typeKey = `type:${typeBucket.label}`;
            const typeExpanded = !!state.expandedFolders[typeKey];
            rows.push({
                rowType: 'type',
                key: typeKey,
                label: typeBucket.label,
                level: 0,
                isExpanded: typeExpanded,
                description: '',
                modifiedDate: maxDate(typeBucket.docs),
                modifiedDateTime: maxDate(typeBucket.docs, true),
                files: typeBucket.docs.length
            });
            if (!typeExpanded) {
                return;
            }
            typeBucket.docs.forEach(doc => {
                const docExpanded = !!state.expandedDocs[doc.id];
                const orderedVersions =
                    !isSingleVersionDocument(doc) && doc.versions
                        ? sortVersionsNewestFirst(doc.versions)
                        : [];
                const latest =
                    orderedVersions.length > 0 ? orderedVersions[0] : undefined;
                // a multi-version folder row represents its latest version
                rows.push({
                    rowType: 'doc',
                    key: `doc:${doc.id}`,
                    // type always resolves from the parent doc's id (a
                    // version can carry a mismatched-case id - see the AGS
                    // remap in mapStateToProps); date from the latest version
                    label: getDocumentDisplayName(
                        {
                            ...(latest || doc),
                            cloudDocumentTypeID: doc.cloudDocumentTypeID
                        },
                        documentTypeOptions
                    ),
                    level: 1,
                    isExpanded: docExpanded,
                    description: getDocumentRawName(doc),
                    document: latest
                        ? {
                              ...doc,
                              mimeType: latest.mimeType || doc.mimeType
                          }
                        : doc,
                    modifiedDate: formatDate(latest || doc),
                    modifiedDateTime: formatDate(latest || doc, true),
                    files: latest
                        ? `V${getVersionDisplayNumber(
                              latest,
                              orderedVersions.length
                          )}`
                        : `V${getVersionDisplayNumber(doc, 1)}`
                });
                if (!docExpanded || orderedVersions.length === 0) {
                    return;
                }
                // expanding reveals the OLDER versions as ordinary rows
                orderedVersions.forEach((version, index) => {
                    if (index === 0) {
                        return;
                    }
                    rows.push({
                        rowType: 'version',
                        key: `version:${version.id}`,
                        // type from the parent doc (see doc row above);
                        // date from this specific version
                        label: getDocumentDisplayName(
                            {
                                ...version,
                                cloudDocumentTypeID: doc.cloudDocumentTypeID
                            },
                            documentTypeOptions
                        ),
                        level: 2,
                        isExpanded: false,
                        description: version.name || '',
                        document: {
                            ...version,
                            mimeType: version.mimeType || doc.mimeType,
                            facilityName: doc.facilityName,
                            jobNumber: doc.jobNumber
                        },
                        parentDocument: doc,
                        modifiedDate: formatDate(version),
                        modifiedDateTime: formatDate(version, true),
                        files: `V${getVersionDisplayNumber(
                            version,
                            orderedVersions.length - index
                        )}`
                    });
                });
            });
        });
        return rows;
    };

    const treeRows = isMobile ? [] : buildTreeRows();

    // Mobile and a row has been selected
    if (
        isMobile &&
        state.selectedRow &&
        Object.keys(state.selectedRow).length > 0
    ) {
        return (
            <>
                <ManageDocumentVersions
                    t={props.t}
                    currentTile={state.currentTile}
                    selectedCloudDocument={state.selectedCloudDocument}
                    totalPages={totalPages}
                    setTableFilter={props.setTableFilter}
                    tableFilters={tableFilters}
                    documentTypeOptions={documentTypeOptions}
                    goBack={goBack}
                    newVersion={newVersion}
                    editDoc={editDoc}
                    downloadDocument={downloadMobileDocument}
                />

                <EditDocumentLibraryModal
                    selectedDocument={props.selectedDocument}
                    colorButton={
                        constants.colors[
                            `${state.currentTile.color}Button` as keyof typeof constants.colors
                        ]
                    }
                />

                <EditDocumentTypeModal
                    colorButton={
                        constants.colors[
                            `${state.currentTile.color}Button` as keyof typeof constants.colors
                        ]
                    }
                />
            </>
        );
    }
    // Mobile and no row selected
    else if (isMobile) {
        return (
            <div
                className={`manage-document${debugCellsClass()}`}
                ref={screenRef}
                data-btn="true"
            >
                <SearchTableForm
                    fieldConfig={fieldConfig}
                    handleSubmit={props.getDocuments}
                    loading={props.loading}
                    colorButton={
                        constants.colors[
                            `${state.currentTile.color}Button` as keyof typeof constants.colors
                        ]
                    }
                    subscribeValueChanges={true}
                    onValueChanges={onSearchValueChanges}
                    t={props.t}
                    showSearchButton={false}
                >
                    {props.canEditDocuments && (
                        // compact + docks into the last filter row's right gap
                        <Button
                            className="table-add-button-compact"
                            bsStyle="link"
                            aria-label={t('manageDocument:newDocument')}
                            title={t('manageDocument:newDocument')}
                            onClick={() => {
                                collapseTable();
                                props.clearSelectedParentID();
                                props.clearSelectedDocumentID();
                                props.toggleEditDocumentModal();
                            }}
                        >
                            <img
                                src={NewVersionIcon}
                                alt=""
                                aria-hidden="true"
                            />
                        </Button>
                    )}
                </SearchTableForm>
                <ReactTable
                    data={tableData}
                    columns={state.columns}
                    getTdProps={getTdProps}
                    pageSize={10}
                    pages={totalPages}
                    page={tableFilters.page - 1}
                    showPageSizeOptions={false}
                    className={`beacon-table -highlight ${state.currentTile.color}`}
                    previousText={t('common:previous')}
                    nextText={t('common:next')}
                    onPageChange={onPageChange}
                    sortable={false}
                    multiSort={false}
                    noDataText={t('common:noDataText')}
                    resizable={false}
                    loading={props.loading}
                    key={'id'}
                />

                <EditDocumentLibraryModal
                    selectedDocument={props.selectedDocument}
                    colorButton={
                        constants.colors[
                            `${state.currentTile.color}Button` as keyof typeof constants.colors
                        ]
                    }
                />

                <EditDocumentTypeModal
                    colorButton={
                        constants.colors[
                            `${state.currentTile.color}Button` as keyof typeof constants.colors
                        ]
                    }
                />
            </div>
        );
    }

    // Desktop
    return (
        <div className={`manage-document${debugCellsClass()}`} ref={screenRef}>
            <Banner
                title={t('bannerTitle')}
                img={currentTile.srcBanner}
                color={currentTile.color}
            />
            <SearchTableForm
                fieldConfig={fieldConfig}
                handleSubmit={props.getDocuments}
                loading={props.loading}
                colorButton={
                    constants.colors[
                        `${state.currentTile.color}Button` as keyof typeof constants.colors
                    ]
                }
                subscribeValueChanges={true}
                onValueChanges={onSearchValueChanges}
                t={props.t}
                showSearchButton={false}
                lg={10}
            >
                {props.canEditDocuments && (
                    <Col>
                        <AddButton
                            className="document-add-button"
                            onClick={() => {
                                collapseTable();
                                props.clearSelectedParentID();
                                props.clearSelectedDocumentID();
                                props.toggleEditDocumentModal();
                            }}
                            label={t(`manageDocument:newDocument`)}
                        />
                    </Col>
                )}
            </SearchTableForm>
            {state.columns && state.columns.length > 0 && (
                <ReactTable
                    data={treeRows}
                    columns={state.columns}
                    getTdProps={getTdProps}
                    getTrProps={(
                        finalState: FinalState,
                        rowInfo: RowInfo | undefined
                    ) =>
                        rowInfo && rowInfo.original
                            ? {
                                  className: `tree-row-${rowInfo.original.rowType}`
                              }
                            : {}
                    }
                    pageSize={totalPages}
                    manual
                    pages={totalPages}
                    page={tableFilters.page - 1}
                    showPageSizeOptions={false}
                    className={`beacon-table -highlight ${state.currentTile.color}`}
                    previousText={t('common:previous')}
                    nextText={t('common:next')}
                    onPageChange={onPageChange}
                    sortable={false}
                    multiSort={false}
                    noDataText={t('common:noDataText')}
                    resizable={false}
                    loading={props.loading}
                />
            )}
            <EditDocumentLibraryModal
                selectedDocument={props.selectedDocument}
                colorButton={
                    constants.colors[
                        `${state.currentTile.color}Button` as keyof typeof constants.colors
                    ]
                }
            />
            <EditDocumentTypeModal
                colorButton={
                    constants.colors[
                        `${state.currentTile.color}Button` as keyof typeof constants.colors
                    ]
                }
            />

            <PreviewDocumentModal
                specificVersion={state.previewSpecificVersion}
                showModal={state.showPreviewDocumentModal}
                document={state.documentToPreview}
                hideModal={() => {
                    setState({ ...state, showPreviewDocumentModal: false });
                }}
                colorButton={
                    constants.colors[
                        `${state.currentTile.color}Button` as keyof typeof constants.colors
                    ]
                }
            />
        </div>
    );
};

const mapStateToProps = (state: IinitialState, ownProps: Iprops) => {
    let tableData = Object.values(state.manageDocument.documentsByID);

    // We need to move all AGSSSchematic to AGSReblancing
    tableData = tableData.map((document: IcloudDocument) => {
        // Set the document type to AGSReblancing
        if (
            document.cloudDocumentTypeID.toUpperCase() ===
            DocumentTypesEnum.AGSSSchematic
        ) {
            document.cloudDocumentTypeID = DocumentTypesEnum.AGSReblancing.toLocaleLowerCase();

            // Now set all the versions as well
            document.versions = document.versions?.map(
                (version: IcloudDocument) => {
                    version.cloudDocumentTypeID =
                        DocumentTypesEnum.AGSReblancing;
                    return version;
                }
            );
        }

        return document;
    });

    let selectedDocument =
        state.manageDocument.documentsByID[
            state.manageDocument.selectedDocumentID
        ];
    selectedDocument = selectedDocument ? selectedDocument : initialDocument;

    if (selectedDocument === initialDocument) {
        map(state.manageDocument.documentsByID, (document: any) => {
            map(document.versions, (version: IcloudDocument) => {
                if (version.id === state.manageDocument.selectedDocumentID) {
                    selectedDocument = version;
                }
            });
        });
    }
    const canEditDocuments = constants.hasSecurityFunction(state.user, [
        constants.securityFunctions.ManageDocumentLibrary.id
    ]);
    const canAddDocuments = constants.hasSecurityFunction(state.user, [
        constants.securityFunctions.ManageGeneralDocuments.id
    ]);
    const canDeleteSystemDocuments = constants.hasSecurityFunction(state.user, [
        constants.securityFunctions.ManageSystemDocuments.id
    ]);

    return {
        selectedDocument,
        tableData,
        totalPages: state.manageDocument.totalPages,
        showEditDocumentModal: state.manageDocument.showEditDocumentModal,
        tableFilters: state.manageDocument.tableFilters,
        loading: selectIsLoading(state),
        user: state.user,
        canEditDocuments,
        canAddDocuments,
        canDeleteSystemDocuments,
        mainCategoryOptions: state?.productInfo?.mainCategoryOptions,
        productInfo: state?.productInfo
    };
};

export default withTranslation('manageDocument')(
    connect(mapStateToProps, {
        getDocumentTypes,
        updateDocumentType,
        deleteDocumentType,
        getDocuments,
        toggleEditDocumentModal,
        setTableFilter,
        setSelectedParentID,
        clearSelectedParentID,
        setSelectedDocumentID,
        clearSelectedDocumentID,
        getCloudDocument,
        deleteVersion,
        getFacilitiesByCountry,
        closeAllModals,
        getProductInfo
    })(ManageDocumentLibrary)
);
